import { defineStore } from "pinia";
import { ref } from 'vue';

export const useContactOverlay = defineStore("contactOverlay", () => {
  /** State **/
  const is_visible = ref<boolean>(false);

  /** Actions **/
    function show(): void {
    console.log("[contact-overlay.show]: showing the overlay");
    is_visible.value = true;
  }
  function hide(): void {
    console.log("[contact-overlay.hide]: hiding the overlay");
    is_visible.value = false;
  }

  return { is_visible, show, hide }
});
